module.exports = __webpack_public_path__ + "img/dealer-icon-1.9b5bfedf.png";